/**
 * Requires
 */

import $ from 'jquery'
import objectFitPolyfill from 'objectFitPolyfill'
window.jQuery = $

/**
 * App Modules
 */

import * as Svg from '../../js/base/svg'
import * as LazyLoad from '../../js/base/lazyload'
import * as Toggle from '../../js/base/toggle'
import * as SmoothScroll from '../../js/base/smooth-scroll'
import * as VideoEmbed from '../../js/base/video-embed'
import * as ExternalLinks from '../../js/base/external-links'
import * as Menu from '../../js/base/menu'
import * as FacebookPixel from '../../js/base/facebook-pixel'
import * as GoogleAnalytics from '../../js/base/analytics'

/**
 * Sections
 */

import * as TessituraSections from './tessitura-sections'

/**
 * Initialisation
 */

Svg.initialise()
LazyLoad.initialise()
Toggle.initialise()
SmoothScroll.initialise()
VideoEmbed.initialise()
ExternalLinks.initialise()
Menu.initialise()
FacebookPixel.initialise()
GoogleAnalytics.initialise()

/**
 * Initialisation
 */

TessituraSections.initialise()
